var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 599,
    viewBox: "0 0 600 599",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_515_4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M586.536 520.26L365.08 298.794L585.335 78.5394C603.297 60.5679 603.297 31.4354 585.335 13.4737C567.364 -4.48799 538.241 -4.48799 520.27 13.4737L300.015 233.729L79.7697 13.4737C61.7982 -4.48799 32.6756 -4.48799 14.704 13.4737C-3.26752 31.4453 -3.26752 60.5777 14.704 78.5394L234.949 298.794L13.4738 520.26C-4.49777 538.231 -4.49777 567.354 13.4738 585.325C22.4596 594.311 34.2306 598.799 46.0116 598.799C57.7925 598.799 69.5635 594.311 78.5493 585.325L300.015 363.86L521.47 585.325C530.456 594.311 542.227 598.799 554.008 598.799C565.789 598.799 577.56 594.311 586.546 585.325C604.498 567.364 604.498 538.231 586.536 520.26Z",
    fill: "#9B9B9B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_515_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 598.809,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoClose);
export default __webpack_public_path__ + "static/media/ico_close.125a54466b9606bf3139a5a5f1c3959f.svg";
export { ForwardRef as ReactComponent };